<script setup lang="ts">
  import { Toaster } from '@ui/components/sonner';
  import { TooltipProvider } from '@ui/components/tooltip';
  import 'vue-sonner/style.css';
</script>

<template>
  <TooltipProvider :delay-duration="150" :skip-delay-duration="300">
    <div
      id="content"
      class="relative w-screen h-screen flex-col justify-center bg-secondary overflow-hidden"
    >
      <div class="w-full h-full p-2">
        <router-view />
      </div>
    </div>
  </TooltipProvider>

  <Toaster close-button />
</template>

<style scoped>
  html,
  body {
    font-family: 'Karla', sans-serif;
    margin: 0;
  }
</style>
